/*
 * @file: messages.js
 * @description: All errors and success messages defined here
 * */
export const USERNAME_ERR = 'Username is required';
export const PASSWORD_ERR = 'Password is required';
export const INVALID_ERR = 'Please enter correct credentials';
export const SERVER_ERR = 'Internal Server Error. Please check the connection';
export const LOGGED_SUCCESS = 'logged in Successfully';
export const TOKEN_EXPIRE =
  'Your Session has been expired! Please login again.';
export const EPIC_ERR = 'Epic users cannot login to standalone application';
